/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getMfrCodeAsync } from './DataActionExtension.g';
import { IMfrCodeClass } from './DataServiceEntities.g';
// @ts-ignore
import { getSelectedProductIdFromActionInput } from '@msdyn365-commerce-modules/retail-actions/dist/lib/utilities/utils';
/**
 * GetMfrCode Input Action
 */
export class GetMfrCodeInput implements Msdyn365.IActionInput {
    public readonly productId: number;
    constructor(productId: number) {
        this.productId = productId;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `${this.productId}`;
    public getCacheObjectType = () => 'HEI-MfrCode';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetMfrCodeData {
    text: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    const productId = getSelectedProductIdFromActionInput(args);
    return new GetMfrCodeInput(+productId);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetMfrCodeInput, ctx: Msdyn365.IActionContext): Promise<IMfrCodeClass> {
    const response = await getMfrCodeAsync({ callerContext: ctx }, input.productId);
    return response;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IMfrCodeClass>>action,
    // TODO: Give your data action a unique id
    id: 'GetMfrCode',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
